export interface FAQItem {
  question: string;
  answer: string;
}

export const faqItems: FAQItem[] = [
  {
    question: '每日大赛Yandex官网入口在哪里？',
    answer: '每日大赛Yandex官网入口即为本网站首页。您可以直接通过浏览器访问我们的官方网站，在首页即可找到参赛入口。建议将官网加入书签以便随时访问。',
  },
  {
    question: 'Yandex每日大赛报名需要什么条件？',
    answer: '报名条件很简单：年满18周岁、拥有有效的Yandex账户、完成实名认证。每天上午10:00开启报名通道，完全免费，不收取任何费用。',
  },
  {
    question: '参赛需要下载什么软件吗？',
    answer: 'Yandex每日大赛是纯网页端赛事，无需下载任何软件。您只需要使用浏览器访问官方入口即可参赛。推荐使用Chrome、Yandex浏览器或Edge，确保获得最佳体验。',
  },
  {
    question: '每日大赛的奖励是怎么计算的？',
    answer: '奖励分为日奖、周奖、月奖和年奖四个层级。日奖根据当日排名即时发放，前100名均有奖励。周奖和月奖根据积分累计排名评选。年度总决赛冠军奖励高达10万元。',
  },
  {
    question: '每天可以参加几次比赛？',
    answer: '每位注册用户每天仅限参加一次正式比赛。但您可以参与赛前热身题和赛后练习模式，这些不计入正式排名，是提升技能的好方法。',
  },
  {
    question: 'Yandex每日大赛的比赛内容是什么？',
    answer: '比赛内容涵盖逻辑推理、数学计算、编程算法、知识问答等多个维度。题目由AI系统动态生成，保证每场比赛的题目都不相同，确保公平公正。',
  },
  {
    question: '如何查询自己的历史成绩和排名？',
    answer: '登录账户后进入"个人中心"→"比赛记录"，可查看所有历史比赛成绩、排名变化趋势图和详细数据分析报告。',
  },
  {
    question: '比赛中遇到技术问题怎么办？',
    answer: '如果在比赛中遇到技术故障，请立即截图保存证据，然后通过官网底部的"联系我们"提交问题反馈。我们的技术支持团队会在30分钟内响应。',
  },
];